import { FC, memo } from "react";
import { Button, Icon } from "@smile2impress/components/relaunch";
import { useGoToBooking } from "hooks/useGoToBooking";

import { CtaButtonProps } from "./CtaButton.types";
import Link from "../Link";

export const CtaButton: FC<CtaButtonProps> = memo(
    ({ variant, text, link, iconLeft, iconRight, onClick, dataTestId }) => {
        const { goToBooking } = useGoToBooking();

        if (!onClick && !link) onClick = goToBooking;

        return (
            <Button
                w={["100%", "100%", "auto"]}
                {...(onClick ? { onClick } : {})}
                {...(link && {
                    as: Link,
                    href: link,
                })}
                {...(variant ? { variant } : {})}
                data-testid={dataTestId}
            >
                <>
                    {iconLeft && (
                        <Icon
                            w={1}
                            h={1}
                            as={iconLeft}
                            verticalAlign="baseline"
                            mr=".3em"
                            color="text.baseInverse"
                        />
                    )}
                    {text}
                    {iconRight && (
                        <Icon
                            w={1}
                            h={1}
                            as={iconRight}
                            verticalAlign="baseline"
                            ml=".3em"
                            color="text.baseInverse"
                        />
                    )}
                </>
            </Button>
        );
    }
);
